<script setup lang="ts">
import { Dialog, Button, Select } from 'primevue';
import { ref } from 'vue';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import { useProductStore } from 'shared/products/stores/productStore';
import type { Product } from 'shared/products/domain/product';

const emit = defineEmits(['executeProductSearch', 'clearProductSearch'])

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

const productStore = useProductStore();
const selectedProduct = ref<Product>();
const visible = ref<boolean>(false);
const searchActive = ref<boolean>(false);


function executeSearchProduct() {
  if(!selectedProduct.value) return;
  visible.value = false;
  searchActive.value = true;
  emit('executeProductSearch');
}

function clear() {
  visible.value = false;
  searchActive.value = false;
  selectedProduct.value = undefined;
  emit('clearProductSearch')
}

defineExpose({
  visible,
  searchActive,
  selectedProduct,
  clear
});

</script>

<template>
  <Dialog modal :header='translations.products.actions.filterByProduct' v-model:visible="visible" class="w-96">
    <label for="storage-area-drawer-type">{{ translations.generic.product }}</label>
    <Select v-model="selectedProduct" :options="productStore.sortedByName" optionLabel="name" filter :placeholder="translations.dialogs.search.selectAProduct"
      class="w-full" />

    <template #footer>
      <Button :label="translations.generic.filter" icon="pi pi-search"
        @click="executeSearchProduct"></Button>
    </template>
  </Dialog>
</template>
